import { createSlice } from '@reduxjs/toolkit'

export const ChartStore = createSlice({
  name: 'chartStore',
  initialState: {
    chartAnalysis: {
      c: [],
      h: [],
      l: [],
      o: [],
      s: "",
      t: [],
      v: [],
    },
    datafeedInstruments: [],
    stockInformation: {},
    values: {},
    valuesValuation: {}
  },
  reducers: {
    setChartAnalysisData: (state: any, actions: any) => {
      state.chartAnalysis = { ...actions?.payload }
    },
    setDatafeedInstruments: (state: any, actions: any) => {
      state.datafeedInstruments = actions?.payload
    },
    setStockInformation: (state: any, actions: any) => {
      state.stockInformation = actions?.payload
    },
    setValues: (state: any, actions: any) => {
      state.values = actions?.payload
    },
    setValuesValuation: (state: any, actions: any) => {
      state.valuesValuation = actions?.payload
    },
  }
})

export const {
  setChartAnalysisData,
  setDatafeedInstruments,
  setStockInformation,
  setValues,
  setValuesValuation
} = ChartStore.actions

export default ChartStore.reducer